<template>
    <vx-expandable-card>
        <template v-slot:header> Two-Factor Authentication </template>

        <template v-slot:content>
            <div class="flex flex-col gap-6 mt-3">
                <vx-button block size="lg" @click.prevent="disable" :loading="form.busy" color="danger">
                    Disable Two-Factor Authentication
                </vx-button>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { ref } from 'vue';
import { useToasted } from '~/composables/useToasted';
import { VxButton, VxExpandableCard } from '@voxie/frontend-components';

defineProps({
    user: {
        type: Object,
        required: true,
    },
});

const toasted = useToasted();
const form = ref(new SparkForm({}));

const disable = () => {
    Spark.delete('/settings/two-factor-auth', form.value)
        .then(() => {
            Bus.$emit('updateUser');
        })
        .catch((e) => {
            console.error(e);
            toasted.global.platform_error();
        });
};
</script>
